import { SegmentedControl } from "~/components/design-system/components"

type Source = "follow" | "own"

const KIND = {
  dates: { own: "Own dates", label: "Where the dates come from" },
  stores: { own: "Own set", label: "Where the stores come from" },
} as const

/**
 * Where dates or stores come from: "Follow <folder>" or the package's or subfolder's own.
 * Picking the other segment saves the switch.
 */
export function FollowOrOwn({
  of,
  folderName,
  following,
  saving,
  disabledReason,
  onChange,
}: {
  of: keyof typeof KIND
  folderName: string
  following: boolean
  saving: boolean
  /** Why the switch can't be used right now; shown on hover. */
  disabledReason: string | undefined
  onChange: (following: boolean) => void
}) {
  const reason = disabledReason ?? (saving ? "Saving…" : undefined)
  return (
    <SegmentedControl<Source>
      aria-label={KIND[of].label}
      size="sm"
      options={[
        { value: "follow", label: `Follow ${folderName}` },
        { value: "own", label: KIND[of].own },
      ]}
      value={following ? "follow" : "own"}
      onValueChange={(source) => onChange(source === "follow")}
      requires="edit"
      disabled={reason !== undefined}
      allowedTitle={reason}
      wrapperClassName="self-start"
    />
  )
}
